
<div :id="id" ref="alertBanner" role="alert" :class="bannerClass">
  <div :class="fullPageBanner ? 'text-center' : 'flex items-center'">
    <span v-if="!fullPageBanner" class="pr-8">
      <slot name="icon">
        <AlertExclamationMark v-if="icon == 'alert'" :color="exclamationColor" />
        <SuccessIconMd v-if="icon == 'success'" />
        <TrustSafetyShieldIcon v-if="icon == 'trust'" />
        <InactiveEyeIcon v-if="icon == 'inactive'" />
        <MessageSentOutlineIcon v-if="icon == 'recruit'" />
      </slot>
    </span>
    <span id="banner-message" :class="spanClasses" @keyup.enter="redirect" @click="redirect">
      <slot></slot>
    </span>
  </div>
  <button v-if="dismissable" class="focus:outline-brand-contrast" @click="hideBanner">
    <span class="sr-only">Close Banner Button</span>
    <IconClose />
  </button>
</div>
